module.exports = __webpack_public_path__ + "static/media/ol.ed60302d.png";